<template>
    <b-modal id="bv-modal-add-task-reason" size="lg" title="Adicionar um novo motivo" scrollable centered no-stacking>
        <b-container fluid>
            <form id="add-task-reason">
                <div class="row">
                    <div class="col-md-9">
                        <div class="form-group">
                            <label for="task-reason-name">Nome do Motivo</label>
                            <input type="text" class="form-control" id="task-reason-name" v-model="form.name"
                                placeholder="nome do motivo">
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Ativo</label>
                            <div class="custom-control custom-switch mb-3">
                                <input v-model="form.active" type="checkbox" class="custom-control-input"
                                    id="task_reason_active" />
                                <label class="custom-control-label" for="task_reason_active">
                                    {{ form.active ? 'SIM' : 'NÃO' }}
                                </label>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </b-container>

        <template #modal-footer>
            <div class="d-flex flex-row-reverse justify-content-between" style="width: 100%;">
                <button type="submit" @click.prevent="submitForm" class="btn btn-primary" :disabled="loading">
                    <span v-if="loading">
                        <i class="fas fa-spinner fa-pulse"></i> Aguarde...
                    </span>
                    <span v-else>
                        <i class="fas fa-save"></i> Salvar
                    </span>
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { taskManagerAxios } from '../connections/taskApiConnection';

export default {
    name: "ReasonTaskModal",
    data() {
        return {
            loading: false,
            dataEdit: {},
            form: {
                name: '',
                active: true,
                default_form: null,
                tag: 'co',
            }
        }
    },
    computed: {
        isEditing() {
            return this.dataEdit && this.dataEdit._id;
        },
    },
    methods: {
        openModal(data = null) {
            this.resetForm();
            if (data) {
                this.dataEdit = data;
                this.loadFormData(data);
            }
            this.$bvModal.show('bv-modal-add-task-reason');
        },
        closeModal(data = null) {
            this.loading = false;
            this.resetForm();
            if (data) this.$emit('updateReasonTable', data);
            this.$bvModal.hide('bv-modal-add-task-reason');
        },
        loadFormData(data) {
            this.form._id = data._id;
            this.form.name = data.name;
            this.form.active = data.active;
            this.form.default_form = data.default_form;
        },
        resetForm() {
            this.form = { name: '', active: true, default_form: null, tag: 'co' };
            this.dataEdit = {};
        },
        validateForm() {
            if (!this.form.name) {
                Swal.fire({ type: 'error', text: "Campo 'Nome' é obrigatório!" });
                return false;
            }
            return true;
        },
        async submitForm() {
            if (!this.validateForm()) return;
            this.loading = true;
            const formData = { ...this.form };
            try {
                if (this.form._id) {
                    Swal.fire({
                        title: 'Deseja alterar esse motivo?',
                        text: 'As alterações realizadas nesse motivo serão aplicadas apenas para as próximas tarefas abertas. Tarefas anteriormente abertas com esse motivo permanecerão inalteradas.',
                        showCancelButton: true,
                        confirmButtonText: 'Sim',
                        cancelButtonText: 'Não',
                        type: 'question',
                        showCloseButton: true,
                        reverseButtons: true
                    }).then(async ({ value }) => {
                        if (!value) return this.loading = false;
                        const { data } = await taskManagerAxios.put(`/reasons/${this.form._id}`, formData);
                        Swal.fire({ type: 'success', text: 'Motivo atualizado com sucesso.' });
                        this.closeModal(data);
                    });
                } else {
                    const { data } = await taskManagerAxios.post('/reasons', formData);
                    Swal.fire({ type: 'success', text: 'Motivo salvo com sucesso.' });
                    this.closeModal(data);
                }
            } catch (error) {
                console.error(error);
                Swal.fire({ type: 'error', text: 'Falha ao salvar motivo! Valide todos os campos e tente novamente.' });
                this.loading = false;
            }
        },
    },
}
</script>

<style scoped>
.custom-control-label {
    font-weight: 500;
}

.custom-switch .custom-control-label::before {
    border-radius: 0.5rem;
}

.custom-switch .custom-control-label::after {
    border-radius: 50%;
}
</style>
